import { SLOT_DIGITS } from './constants';
import { ReelDigit, ReelStrip, ReelWindow } from './styles';
import {
  digitAtPlace,
  phaseOf,
  reelTransform,
  spinsContinuously,
} from './utils';

interface DigitReelProps {
  place: number;
  initialValue: number;
  incrementValue: number;
  registerReel: (
    place: number,
    continuous: boolean,
    el: HTMLSpanElement | null
  ) => void;
}

const DigitReel = ({
  place,
  initialValue,
  incrementValue,
  registerReel,
}: DigitReelProps) => {
  const continuous = spinsContinuously(place, incrementValue);
  const initialPosition = continuous
    ? phaseOf(initialValue, place)
    : digitAtPlace(initialValue, place);

  return (
    <ReelWindow aria-hidden>
      <ReelStrip
        ref={el => registerReel(place, continuous, el)}
        style={{ transform: reelTransform(initialPosition) }}
      >
        {SLOT_DIGITS.map((char, idx) => (
          <ReelDigit key={idx}>{char}</ReelDigit>
        ))}
      </ReelStrip>
    </ReelWindow>
  );
};

export default DigitReel;
